import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { map } from "rxjs/operators";
import { environment } from "src/environments/environment.ipt.local";
import {
	IPermissions,
	IPermissionsResponse,
	ProviderProfileResponse,
	ProviderRoleResponse,
} from "../interfaces/permissions";
import { IHttpDatumResponse, IMapper } from "../interfaces/req-res";

@Injectable({
	providedIn: "root",
})
export class UserPermitsService
	implements IMapper<IPermissionsResponse, IPermissions>
{
	private authBasePath = `${environment.urlBackendAuth}/${environment.slugBackend}`;
	private portalBasePath = `${environment.urlBackendPortal}/${environment.slugBackend}`;

	constructor(private http: HttpClient) {}

	recordLogUserToSession() {
		return this.http.get(`${this.portalBasePath}/log/registrar-log-login`);
	}

	findPermissionByUserLogged(): Observable<
		IHttpDatumResponse<IPermissions[]>
	> {
		if (environment.authProvider === "prov-auth") {
			return this.findPermissionsByProviderProfile();
		}

		return this.http
			.get<IHttpDatumResponse<IPermissionsResponse[]>>(
				`${this.authBasePath}/listar-permisos-usuarios`
			)
			.pipe(
				map((response) => ({
					data: this.mapperList(response.data),
				}))
			);
	}

	private findPermissionsByProviderProfile(): Observable<
		IHttpDatumResponse<IPermissions[]>
	> {
		return this.http
			.get<ProviderProfileResponse>(
				`${environment.urlBackendAuth}/${environment.slugBackend}/person/profile/`
			)
			.pipe(
				map((response) => ({
					data: this.mapperProviderRoles(response.roles || []),
				}))
			);
	}

	mapperList(dataList: IPermissionsResponse[]): IPermissions[] {
		return dataList.map((be) => ({
			name: be.per_name?.toUpperCase(),
			description: be.description?.toUpperCase(),
		}));
	}

	private mapperProviderRoles(
		dataList: ProviderRoleResponse[]
	): IPermissions[] {
		return dataList.map((role) => ({
			name: role.name?.toUpperCase(),
			description: (role.description || role.name || "").toUpperCase(),
		}));
	}
}
